import { inject, Injectable } from '@angular/core';
import { AuthService as Auth0AuthService } from '@auth0/auth0-angular';
import { filter, map, Observable, of } from 'rxjs';
import { IAuthUser } from './auth-user';
import { authUserMock } from './auth-user.mock';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private auth0AuthService = inject(Auth0AuthService);
    private readonly inTest = inject(EnvironmentService).appEnvironment.stage === 'test';

    getAuthUser(): Observable<IAuthUser> {
        if (this.inTest) {
            return of(authUserMock);
        }

        return this.auth0AuthService.user$.pipe(
            filter(user => user !== null && user !== undefined),
            map(user => user as IAuthUser)
        );
    }

    getAccessToken(): Observable<string> {
        if (this.inTest) {
            return of('accessTokenMock');
        }

        return this.auth0AuthService.getAccessTokenSilently().pipe(filter(token => !!token));
    }
}
